export default "__VITE_ASSET__BeuZXYn$__"